import React, { ReactElement } from 'react';
import WrappedAppbar from './components/WrappedAppbar';
import WrappedSidebar from './components/WrappedSidebar';

interface Props {
    children: ReactElement;
}

const Navigation = (props: Props): ReactElement => {
    const { children } = props;
    return (
        <>
            <WrappedAppbar />
            <WrappedSidebar>{children}</WrappedSidebar>
        </>
    );
};

export default Navigation;
